import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { OptionsWithAssignee } from 'components/common/MyCustomSelect/components/OptionsWithAssignee/OptionsWithAssignee';

import {
    IAssignee,
    IFields,
} from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';
import { Select } from 'components/DesignSystem/Select';

export const UpdatedBy = ({ isSelected, options, onFiltersChanged, isLoading }) => {
    const { control } = useFormContext<IFields>();
    return isSelected ? (
        <div className={classes.selectWrapper}>
            <span className={classes.title}>Updated By</span>
            <Controller
                render={({ field }) => (
                    <Select<IAssignee>
                        id={'battlecards-filters-updated-by'}
                        {...field}
                        onChange={(newValue) => {
                            field.onChange(newValue);
                            onFiltersChanged({ [field.name]: newValue });
                        }}
                        options={options}
                        isClearable={true}
                        components={{
                            Option: OptionsWithAssignee,
                        }}
                        isLoading={isLoading}
                    />
                )}
                name={'updatedBy'}
                control={control}
            />
        </div>
    ) : null;
};
